var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _c(
          "li",
          { staticClass: "active" },
          [
            _c("router-link", { attrs: { to: { name: "HelloWorld" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-clock-o fa-stack-1x " })
              ]),
              _vm._v("Dashboard")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [
          _vm._m(0),
          _vm._v(" "),
          _c("ul", { staticClass: "nav nav-list tree" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "ColorChart" } } }, [
                  _vm._v("Color Chart")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "ContactGrid" } } }, [
                  _vm._v("Contact Grid")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Buttons" } } }, [
                  _vm._v("Buttons")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Profile" } } }, [
                  _vm._v("Profile")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Typography" } } }, [
                  _vm._v("Typography")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "TooltipAndPopover" } } },
                  [_vm._v("Tooltip & Popover")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Tabs" } } }, [
                  _vm._v("Tabs")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Cards" } } }, [
                  _vm._v("Cards")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Modals" } } }, [
                  _vm._v("Modals")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "SweetAlert" } } }, [
                  _vm._v("Alert")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Timeline" } } }, [
                  _vm._v("Timeline")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "Notifications" } } },
                  [_vm._v("Notifications")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "ListGroup" } } }, [
                  _vm._v("List Group")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Carousal" } } }, [
                  _vm._v("Carousel")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Dragable" } } }, [
                  _vm._v("Dragable & Swipe view")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "Loadingspinner" } } },
                  [_vm._v("Loading Spinner")]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "Forms" } } }, [
              _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                _c("i", { staticClass: "fa fa-map-marker fa-stack-1x " })
              ]),
              _vm._v("Forms")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("li", [
          _vm._m(3),
          _vm._v(" "),
          _c("ul", { staticClass: "nav nav-list tree" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Tables" } } }, [
                  _vm._v("Tables")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "TablesSelect" } } }, [
                  _vm._v("Tables With Select")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "SupportTicket" } } },
                  [_vm._v("Support Ticket")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "ContactAndEmployee" } } },
                  [_vm._v("Contact And Employee")]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._m(4),
          _vm._v(" "),
          _c("ul", { staticClass: "nav nav-list tree" }, [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Calendar" } } }, [
                  _vm._v("Calendar")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "ChatApp" } } }, [
                  _vm._v("Chat App")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: { name: "Login" } } }, [
                  _vm._v("Login Page")
                ])
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-map-marker fa-stack-1x " })
      ]),
      _vm._v(" UI Elements "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "#" } }, [_vm._v("Progressbar")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("Breadcrumb")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-bell fa-stack-1x " })
      ]),
      _vm._v("Tables "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-usd fa-stack-1x " })
      ]),
      _vm._v("App "),
      _c("i", {
        staticClass: "fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c5c428a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c5c428a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/partials/sidebar.vue
// module id = null
// module chunks = 